import { render, staticRenderFns } from "./LavoraConNoi.vue?vue&type=template&id=22097588&scoped=true"
import script from "./LavoraConNoi.vue?vue&type=script&lang=js"
export * from "./LavoraConNoi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22097588",
  null
  
)

export default component.exports